import React from 'react';

const GeneralSettingsSection = ({ title, description, children, className = '' }) => (
  <section className={`mb-8 ${className}`.trim()}>
    <div className="mb-4">
      <h2 className="text-lg font-semibold text-gray-800">{title}</h2>
      {description ? <p className="mt-1 text-sm text-gray-500">{description}</p> : null}
    </div>
    <div className="space-y-4">{children}</div>
  </section>
);

export default GeneralSettingsSection;
